import { MedplumClient } from '@medplum/core';

import { env } from './env';

/**
 * Singleton MedplumClient instance for FHIR API interactions
 *
 * MedplumClient automatically handles session persistence in localStorage.
 * On initialization, it will restore any existing session automatically.
 *
 * Configured with:
 * - baseUrl: Medplum backend API endpoint
 * - clientId: OAuth2 client ID for authentication
 * - onUnauthenticated: Redirect to sign-in when token expires
 */
export const medplum = new MedplumClient({
	baseUrl: env.VITE_MEDPLUM_BASE_URL,
	clientId: env.VITE_MEDPLUM_CLIENT_ID,
	cacheTime: 0,
	onUnauthenticated: () => {
		// Skip redirect when using mocks (e2e tests)
		if (import.meta.env.VITE_MOCK_API === 'true') {
			return;
		}

		window.location.href = '/';
	},
});
